import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function scrollPageToTop(behavior: ScrollBehavior = 'auto') {
  window.scrollTo({ top: 0, left: 0, behavior });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

/** Scrolls to the top on route change, or to a hash target when present. */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const delay = hash ? 500 : 0;
    const timer = window.setTimeout(() => {
      if (hash) {
        const id = hash.replace('#', '');
        const target = document.getElementById(id);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
      }
      scrollPageToTop('auto');
    }, delay);

    return () => window.clearTimeout(timer);
  }, [pathname, hash]);

  return null;
}
